export default __webpack_public_path__ + "static/media/whatsapp.76081526.svg";